import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        stores: [],
        saving: false,
        saveError: ""
    },
  
    getters: {
        loadInProgress(state) {
            return state.loading;
        },
        getStores(state) {
            return state.stores;
        }
    },
  
    mutations: {
        setStores(state, data) {
            state.stores = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.stores = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        }
    },
  
    actions: {
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        saveStore(context, options) {
            context.commit("saving");

            api.saveStore(
                options.store,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of stores (which will include the changes we requested)
                        context.commit("setStores", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadStores(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchStores({
                    success: function(response) {
                        context.commit("setStores", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");
                    }
                });
            });
        }
    }
}
